import { render, staticRenderFns } from "./ImpulseChart.vue?vue&type=template&id=3e846ee2&scoped=true"
import script from "./ImpulseChart.vue?vue&type=script&lang=ts"
export * from "./ImpulseChart.vue?vue&type=script&lang=ts"
import style0 from "./ImpulseChart.vue?vue&type=style&index=0&id=3e846ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e846ee2",
  null
  
)

export default component.exports